import { MenuIdInsight } from '@jira/navigation-apps__constants/src/MenuIdInsight.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskCmdbAssetsObjectTypeConfigurationRoute } from '@jira/router-routes__servicedesk-cmdb-routes/src/servicedeskCmdbAssetsObjectTypeConfigurationRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getCmdbResources } from './common/getCmdbResources.tsx';
import ConfigureObjectType, {
	LazyServicedeskCmdbConfigureObjectType,
} from './ui/configure-object-type/index.tsx';
import { AssetsAppRedirect } from './ui/redirect/assets-app-redirect/index.tsx';

export const servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry: Route = createEntry(
	servicedeskCmdbAssetsObjectTypeConfigurationRoute,

	() => ({
		group: 'servicedesk',
		layout: globalLayout,
		navigation: { menuId: MenuIdInsight },
		// eslint-disable-next-line no-restricted-syntax
		component: fg('assets_as_an_app_v2') ? AssetsAppRedirect : ConfigureObjectType,
		resources: getCmdbResources(),
		forPaint: [LazyAtlassianNavigation, LazyServicedeskCmdbConfigureObjectType],

		meta: {
			reporting: {
				id: APP_NAMES.INSIGHT_OBJECT_TYPE_CONFIGURATION,
				packageName: toPackageName(APP_NAMES.INSIGHT_OBJECT_TYPE_CONFIGURATION),
				teamName: 'astral',
			},
		},

		ufoName: 'service-management.insight-cmdb-object-type-configuration',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
